/**
 * 文字リンクの形。使い分けは DESIGN.md。
 * button・a・Link のどれにも付けられるよう、部品ではなくクラスで持つ。
 */

/** 文章の中のリンク。 */
export const BODY_LINK_CLASS = "cursor-pointer text-accent hover:underline";

/** 文章の外に単独で置くリンク。 */
export const ACTION_LINK_CLASS =
	"cursor-pointer text-caption font-medium text-fg-2 underline underline-offset-3 hover:text-fg-0 disabled:cursor-not-allowed disabled:text-fg-2 disabled:opacity-50";

/** 編集の行のファイル名。 */
export const PATH_LINK_CLASS =
	"cursor-pointer text-fg-2 underline-offset-3 hover:text-fg-0 hover:underline";
